import PropTypes from 'prop-types';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { connectAsync, defer } from 'iguazu';
import requireLogin from '../requireLogin';

const AuthenticationWrapper = ({ loadStatus, isAuthenticated, children }) => (
  loadStatus.all === 'loading' || !isAuthenticated ? null : children
);

AuthenticationWrapper.propTypes = {
  loadStatus: PropTypes.shape({
    all: PropTypes.string,
  }).isRequired,
  isAuthenticated: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

AuthenticationWrapper.defaultProps = {
  isAuthenticated: false,
};

const loadDataAsProps = ({ store: { dispatch }, ownProps: { router } }) => ({
  isAuthenticated: defer(() => dispatch(requireLogin(router))),
});

export const ComponentUnderTest = AuthenticationWrapper;

const hocChain = compose(
  oneAppModuleWrapper(AuthenticationWrapper),
  connectAsync({ loadDataAsProps })
);

export default hocChain(AuthenticationWrapper);
